import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { getTotal, getCartProducts } from "../../../reducers";
import {
  addToCart,
  addToWishlist,
  setSearchedProductsArray,
  emptySearchedProductsArray,
  setImgUrl,
} from "../../../actions";
import { SyncLoader, CircleLoader } from "react-spinners";

import ProductListItem from "./product-list-item";
import {
  auth,
  addCartItemTofirestore,
  addWishlistTofirestore,
} from "../../../firebase/firebase.utils";

import { Helmet } from "react-helmet";

import { withRouter } from "react-router-dom";

import "./product-listing.css";
import { toast } from "react-toastify";
import Axios from "axios";
import { fetchOnce } from "./product-listing-cache";

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The product API fails now and then (a 500, or a body with only
// `message`/`error`). Retry a couple of times, and throw on a bad answer so
// fetchOnce never caches it as an empty page.
const requestProducts = async (url, config, retries = 2) => {
  let lastError;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const res = await Axios.get(url, config);
      if (res && res.data && Array.isArray(res.data.products)) {
        return res.data;
      }
      lastError = new Error((res && res.data && res.data.message) || "No products in the answer");
    } catch (error) {
      lastError = error;
    }
    // eslint-disable-next-line no-await-in-loop
    if (attempt < retries) await pause(700 * (attempt + 1));
  }
  throw lastError;
};

class ProductListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasMoreItems: true,
      page: 1,
      notFound: false,
      products: 0,
      imageUrl: "",
    };
  }

  componentDidMount = async () => {
    this.props.emptySearchedProductsArray();
    const query = new URLSearchParams(this.props.location.search);
    const categoryId = query.get("category_id");
    const shop_name = query.get("shop_name");
    let imageUrl = query.get("imageUrl");

    imageUrl = imageUrl
      ? imageUrl
          .replace("rechargeRequests/", "rechargeRequests%2F")
          .replaceAll(" ", "%20")
      : "";

    this.setState({ imageUrl });

    // --------------------------------------------------------------------
    // CASE 1 : SEARCH BY IMAGE
    // --------------------------------------------------------------------
    if (imageUrl) {
      console.log("image search");

      const cacheKey = `img:${imageUrl}-cat:Default-page:1`;

      try {
        const response = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
          return requestProducts("/api/products/search-by-image", {
            params: {
              imgId: imageUrl,
              framePosition: 1,
              filterByCategory: "Default",
            },
          });
        });

        if (response?.products?.length > 0) {
          this.setState({ products: response.products.length });
          this.props.setSearchedProductsArray(
            50,
            response.products,
            response.totalRecords
          );
        } else {
          this.setState({ notFound: true });
        }
      } catch (error) {
        console.log(error);
      }

      return;
    }

    // --------------------------------------------------------------------
    // CASE 2 : SHOP / VENDOR PRODUCTS
    // --------------------------------------------------------------------
    if (shop_name) {
      const vendorId = this.props.match.params.id;

      const cacheKey = `vendor:${vendorId}-cat:Default-page:${this.state.page}`;

      const response = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
        return requestProducts("/api/products/vendor-products", {
          params: {
            vendorId,
            framePosition: this.state.page,
            filterByCategory: "Default",
          },
        });
      });

      if (response?.products?.length > 0) {
        this.setState({ products: response.products.length });
        this.props.setSearchedProductsArray(
          response.totalRecords > 50 ? 50 : response.totalRecords,
          response.products,
          response.totalRecords
        );
      } else {
        this.setState({ notFound: true });
      }

      return;
    }

    // --------------------------------------------------------------------
    // CASE 3 : CATEGORY ONLY (no API call in your code)
    // --------------------------------------------------------------------
    if (categoryId) {
      console.log(categoryId);
      return;
    }

    // --------------------------------------------------------------------
    // CASE 4 : NORMAL SEARCH
    // --------------------------------------------------------------------
    const keyword = this.props.match.params.id;
    const framePosition = this.state.page;

    const cacheKey = `search:${keyword}-cat:Default-page:${framePosition}`;

    const data = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
      return requestProducts("/api/products/search", {
        params: {
          keyword,
          framePosition,
          filterByCategory: "Default",
        },
      });
    });

    if (data?.products?.length > 0) {
      this.setState({ products: data.products.length });
      this.props.setSearchedProductsArray(50, data.products, data.totalRecords);
    } else {
      this.setState({ notFound: true });
    }
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    console.log(nextProps.filterByCategory);

    // --------------------------------------------------------------------
    // CASE 1: IMAGE URL CHANGED
    // --------------------------------------------------------------------
    if (nextProps.imageUrl && nextProps.imageUrl !== this.props.imageUrl) {
      this.setState({
        hasMoreItems: true,
        page: 1,
        notFound: false,
        products: 0,
      });

      this.props.setSearchedProductsArray(0, []);
      this.props.setLoader(true);

      const query = new URLSearchParams(nextProps.location.search);
      const categoryId = query.get("category_id");
      const shop_name = query.get("shop_name");

      let imageUrl = query.get("imageUrl");
      imageUrl = imageUrl
        ? imageUrl
            .replace("rechargeRequests/", "rechargeRequests%2F")
            .replaceAll(" ", "%20")
        : "";

      this.setState({ imageUrl });

      if (imageUrl) {
        const cacheKey = `img:${imageUrl}-cat:Default-page:1`;

        try {
          const response = await fetchOnce(
            cacheKey,
            5 * 60 * 1000,
            async () => {
              return requestProducts("/api/products/search-by-image", {
                params: {
                  imgId: imageUrl,
                  framePosition: 1,
                  filterByCategory: "Default",
                },
              });
            }
          );

          if (response?.products?.length > 0) {
            this.setState({ products: response.products.length });
            this.props.emptySearchedProductsArray();
            this.props.setSearchedProductsArray(
              50,
              response.products,
              response.totalRecords
            );
          } else {
            this.setState({ notFound: true });
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.props.setLoader(false);
    }

    // --------------------------------------------------------------------
    // CASE 2: FILTER BY CATEGORY CHANGED
    // --------------------------------------------------------------------
    if (
      nextProps.filterByCategory &&
      this.props.filterByCategory !== nextProps.filterByCategory
    ) {
      this.setState({
        hasMoreItems: true,
        page: 1,
        notFound: false,
        products: 0,
      });

      this.props.setSearchedProductsArray(0, []);
      this.props.setLoader(true);

      const query = new URLSearchParams(nextProps.location.search);
      const categoryId = query.get("category_id");
      const shop_name = query.get("shop_name");

      let imageUrl = query.get("imageUrl");
      imageUrl = imageUrl
        ? imageUrl
            .replace("rechargeRequests/", "rechargeRequests%2F")
            .replaceAll(" ", "%20")
        : "";

      this.setState({ imageUrl });

      // ---------------------------------------------------------
      // (A) IMAGE SEARCH + CATEGORY FILTER
      // ---------------------------------------------------------
      if (imageUrl) {
        const cacheKey = `img:${imageUrl}-cat:${nextProps.filterByCategory}-page:${this.state.page}`;

        try {
          const response = await fetchOnce(
            cacheKey,
            5 * 60 * 1000,
            async () => {
              return requestProducts("/api/products/search-by-image", {
                params: {
                  imgId: imageUrl,
                  framePosition: this.state.page,
                  filterByCategory: nextProps.filterByCategory || "Default",
                },
              });
            }
          );

          if (response?.products?.length > 0) {
            this.setState({ products: response.products.length });
            this.props.emptySearchedProductsArray();
            this.props.setSearchedProductsArray(
              50,
              response.products,
              response.totalRecords
            );
          } else {
            this.setState({ notFound: true });
          }
        } catch (err) {
          console.log(err);
        }

        this.props.setLoader(false);
        return;
      }

      // ---------------------------------------------------------
      // (B) SHOP / VENDOR PRODUCTS WITH FILTERING
      // ---------------------------------------------------------
      if (shop_name) {
        const vendorId = this.props.match.params.id;

        const cacheKey = `vendor:${vendorId}-cat:${nextProps.filterByCategory}-page:${this.state.page}`;

        const response = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
          return requestProducts("/api/products/vendor-products", {
            params: {
              vendorId,
              framePosition: this.state.page,
              filterByCategory: nextProps.filterByCategory,
            },
          });
        });

        if (response?.products?.length > 0) {
          this.setState({ products: response.products.length });
          this.props.emptySearchedProductsArray();
          this.props.setSearchedProductsArray(
            response.totalRecords > 50 ? 50 : response.totalRecords,
            response.products,
            response.totalRecords
          );
        } else {
          this.setState({ notFound: true });
        }

        this.props.setLoader(false);
        return;
      }

      // ---------------------------------------------------------
      // (C) NORMAL SEARCH WITH FILTER
      // ---------------------------------------------------------
      if (!categoryId) {
        const keyword = this.props.match.params.id;

        const cacheKey = `search:${keyword}-cat:${nextProps.filterByCategory}-page:${this.state.page}`;

        const data = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
          return requestProducts("/api/products/search", {
            params: {
              keyword,
              framePosition: this.state.page,
              filterByCategory: nextProps.filterByCategory,
            },
          });
        });

        if (data?.products?.length > 0) {
          this.setState({ products: data.products.length });
          this.props.emptySearchedProductsArray();
          this.props.setSearchedProductsArray(
            50,
            data.products,
            data.totalRecords
          );
        } else {
          this.setState({ notFound: true });
        }
      }

      this.props.setLoader(false);
    }
  };

  getProducts = async () => {
    const query = new URLSearchParams(this.props.location.search);
    const categoryId = query.get("category_id");
    const shop_name = query.get("shop_name");

    const page = this.state.page;
    const filter = this.props.filterByCategory || "Default";

    // -------------------------------------------------------------------
    // CASE 1: IMAGE SEARCH PAGINATION
    // -------------------------------------------------------------------
    if (this.state.imageUrl) {
      const imgId = this.state.imageUrl;

      const cacheKey = `img:${imgId}-cat:${filter}-page:${page}`;

      try {
        const response = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
          return requestProducts("/api/products/search-by-image", {
            params: {
              imgId,
              framePosition: page,
              filterByCategory: filter,
            },
          });
        });

        if (response?.products?.length > 0) {
          this.setState({ products: response.products.length });

          this.props.setSearchedProductsArray(
            parseInt(this.props.totalResults) + response.products.length,
            response.products,
            response.totalRecords
          );
        } else {
          // A later page with nothing more ends the list; it must not hide
          // the products already shown.
          this.setState({ hasMoreItems: false });
        }
      } catch (error) {
        console.log(error);
        throw error;
      }

      return;
    }

    // -------------------------------------------------------------------
    // CASE 2: VENDOR PRODUCTS PAGINATION
    // -------------------------------------------------------------------
    if (shop_name) {
      const vendorId = this.props.match.params.id;

      const cacheKey = `vendor:${vendorId}-cat:${filter}-page:${page}`;

      const response = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
        return requestProducts("/api/products/vendor-products", {
          params: {
            vendorId,
            framePosition: page,
            filterByCategory: filter,
          },
        });
      });

      if (response?.products?.length > 0) {
        this.setState({ products: response.products.length });

        this.props.setSearchedProductsArray(
          parseInt(this.props.totalResults) + response.products.length,
          response.products,
          response.totalRecords
        );
      } else {
        setTimeout(() => this.setState({ hasMoreItems: false }), 10000);
      }

      return;
    }

    // -------------------------------------------------------------------
    // CASE 3: NORMAL KEYWORD SEARCH PAGINATION
    // -------------------------------------------------------------------
    if (!categoryId) {
      const keyword = this.props.match.params.id;

      const cacheKey = `search:${keyword}-cat:${filter}-page:${page}`;

      const data = await fetchOnce(cacheKey, 5 * 60 * 1000, async () => {
        return requestProducts("/api/products/search", {
          params: {
            keyword,
            framePosition: page,
            filterByCategory: filter,
          },
        });
      });

      if (data?.products?.length > 0) {
        this.setState({ products: data.products.length });

        this.props.setSearchedProductsArray(
          parseInt(this.props.totalResults) + data.products.length,
          data.products,
          data.totalRecords
        );
      } else {
        setTimeout(() => this.setState({ hasMoreItems: false }), 10000);
      }
      return;
    }
  };

  addToReduxAndFirestoreCart = (product, qty) => {
    const { addToCart } = this.props;
    auth.onAuthStateChanged(
      async (userAuth) => await addCartItemTofirestore(userAuth, product, qty)
    );
    addToCart(product, qty);
  };

  addToReduxAndFirestoreWishlist = async (product) => {
    const { addToWishlist, currentUser } = this.props;
    console.log(this.props);
    if (currentUser && currentUser.uid) {
      await addWishlistTofirestore(currentUser, product);
      toast.success("Item addded to wishilist");
    } else {
      alert("You must login first.");
    }
  };

  getData = async () => {
    if (this.props.totalResults < 300) {
      try {
        await this.getProducts();
        if (this.state.loadError) this.setState({ loadError: false });
      } catch (error) {
        // The infinite scroller only asks again when the list grows, so a
        // failed page would stop it for good — offer a retry instead.
        console.log("Loading more products failed:", error);
        this.setState({ loadError: true });
      }
    } else {
      this.setState({
        hasMoreItems: false,
      });
    }
  };

  fetchData = () => {
    const { products, totalResults } = this.props;
    console.log("fetch data is called");
    if (this.state.hasMoreItems) {
      this.setState({ page: parseInt(this.state.page) + 1 }, () => {
        console.log("fetch data is called");
        this.getData();
      });
    } else {
      this.setState({ hasMoreItems: false });
    }
  };

  render() {
    const { products, symbol, active } = this.props;
    console.log(products);

    let renderableProducts = [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
    ];

    if (products.length > 0) {
      renderableProducts = products;
    }
    // jokhoni notun image ba onno kichu diye search korbe ager search kora renderableProducts nai hoye jabe
    if (active) {
      renderableProducts = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
      ];
    }
    console.log(renderableProducts);
    console.log(this.state.notFound);
    return (
      <div style={{ paddingLeft: 5, paddingRight: 5 }}>
        <Helmet>
          <title>{this.props.match.params.id}</title>
        </Helmet>

        <div className="product-wrapper-grid">
          <div className="container-fluid">
            {!this.state.notFound ? (
              <InfiniteScroll
                className="row"
                dataLength={renderableProducts.length} //This is important field to render the next data
                next={this.fetchData}
                hasMore={this.state.hasMoreItems}
                loader={
                  this.state.loadError ? (
                    <div className="sync-loader-container" style={{ textAlign: "center", padding: 20 }}>
                      <div style={{ marginBottom: 10, color: "#666" }}>
                        Couldn't load more products.
                      </div>
                      <button
                        type="button"
                        onClick={() => this.setState({ loadError: false }, this.getData)}
                        style={{
                          padding: "8px 22px",
                          border: "none",
                          borderRadius: 8,
                          background: "#ff4a4e",
                          color: "#fff",
                          fontWeight: 700,
                          cursor: "pointer",
                        }}
                      >
                        Try again
                      </button>
                    </div>
                  ) : (
                    <div className="sync-loader-container">
                      <SyncLoader loading={true} color="#ff4a4e" size={25} />
                    </div>
                  )
                }
                endMessage={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <b>Yay! You have seen it all</b>
                  </div>
                }
              >
                {renderableProducts.map((product, index) => (
                  <div
                    className={`${
                      this.props.colSize === 3
                        ? "col-xl-3 col-md-6 col-grid-box"
                        : "col-lg-" + this.props.colSize
                    } product-container-col`}
                    key={index}
                  >
                    <ProductListItem
                      product={product}
                      symbol={symbol}
                      onAddToWishlistClicked={() =>
                        this.addToReduxAndFirestoreWishlist(product)
                      }
                      onAddToCartClicked={() =>
                        this.addToReduxAndFirestoreCart(product, 1)
                      }
                      key={index}
                      shop={this.props.shop}
                    />
                  </div>
                ))}
              </InfiniteScroll>
            ) : (
              <div className="row">
                <div className="col-sm-12 text-center section-b-space mt-5 no-found">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`}
                    className="img-fluid mb-4"
                  />
                  <h3>
                    Sorry! Couldn't find the product you were looking For!!!{" "}
                  </h3>
                  <p>
                    Please check if you have misspelt something or try searching
                    with other words.
                  </p>
                  <Link
                    to={`${process.env.PUBLIC_URL}/`}
                    className="btn btn-solid"
                  >
                    continue shopping
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    products: state.searchedProducts.products,
    symbol: state.data.symbol,
    totalResults: state.searchedProducts.totalResults,
    currentUser: state.user.currentUser,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    addToCart,
    addToWishlist,
    setSearchedProductsArray,
    emptySearchedProductsArray,
    setImgUrl,
  })(ProductListing)
);
